export const timeData = val => {
  if (val) {
    const date = new Date(val); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "年";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "月";
    let D = date.getDate() + "日";
    return Y + M + D;
  }
  return "";
};
